export const formatCurrency = (val: number): string =>
  new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 2,
  }).format(val || 0);

export interface JournalLineItem {
  account_id: number | null;
  contact_id: number | null;
  description: string;
  debit: number;
  credit: number;
}

export interface JournalBalanceTotals {
  totalDebit: number;
  totalCredit: number;
  difference: number;
  isBalanced: boolean;
}

export const calculateLineTotals = (lines: JournalLineItem[]): JournalBalanceTotals => {
  const totalDebit = lines.reduce((sum, l) => sum + (Number(l.debit) || 0), 0);
  const totalCredit = lines.reduce((sum, l) => sum + (Number(l.credit) || 0), 0);
  const difference = Math.round((totalDebit - totalCredit) * 100) / 100;
  const isBalanced = difference === 0 && totalDebit > 0;

  return {
    totalDebit,
    totalCredit,
    difference,
    isBalanced,
  };
};
